module.exports = __webpack_public_path__ + "img/img151_1.68cf034a.png";